import * as React from 'react';
import ModalContext from '../ModalContext';
export const DrawerTrigger = ({ id, children, showCover = true, canCloseOnEsc = true, coverStyles }) => {
    return (React.createElement(ModalContext.Consumer, null, ({ showTarget, hideTarget, modals }) => {
        return children({
            showTarget: () => showTarget(null, 'drawer', id, {
                showCover,
                coverStyles,
                canCloseOnEsc
            }),
            hideTarget,
            isOpen: modals.some(({ modalId }) => modalId === id)
        });
    }));
};
//# sourceMappingURL=DrawerTrigger.js.map